document.addEventListener("DOMContentLoaded", function() {
  // Select all product prices using the correct class
  const prices = document.querySelectorAll('.price-item.price-item--regular');
  
  // Define the color palette
  const colors = [
    '#8981f7', // Red
    '#fcce29', // Green
    '#f86d5c', // Blue
    '#79d09c', // Magenta
    '#f892fa'  // Cyan
  ];

  // Loop through each price and apply a color in sequence
  prices.forEach((price, index) => {
    const colorIndex = index % colors.length;
    price.style.color = colors[colorIndex];  // Apply the color
  });
});
